export default __webpack_public_path__ + "static/media/Olymp_Regular_Fit.10cea380.jpg";